import config from '../config';
import Layout from '../layout/Layout';
import backgroundImage from '../assets/ClipdeoHome.png'

const Home = () => {
  return (
    <Layout>
      <div className="h-full flex-1 items-center justify-center">
        <div className="text-4xl font-bold mb-40 text-center text-orange-300">
          Welcome to {config.appName}
          <div className="text-lg font-bold italic mt-4 text-center text-orange-200">
            AI Chatbot and Video Fun!!
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Home;

